export default __webpack_public_path__ + "static/media/icon_drawer_close.9f811331.svg";